import {OrderErrorTypeEnum, OrderStatusTypeEnum} from "@/enums/"
import {ICreateOrderDTO} from "@/interface";

export class CreateOrders {
    newOrders: CreateOrder[];
    allIsSuccess: boolean;
    isPending: boolean;
    isFailed: boolean;

    constructor(base?: Partial<CreateOrders>) {
        if (base) {
            Object.assign(this, base);
        }
    }

    public static fromDto(dto: ICreateOrderDTO[]) {
        return new CreateOrders({
            newOrders: dto.map(creatOrder => CreateOrder.fromDto(creatOrder)),
            allIsSuccess: dto.every(order => order.status === OrderStatusTypeEnum.SUCCESS),
            isPending: !!dto.find(order => order.status === OrderStatusTypeEnum.PENDING),
            isFailed: !!dto.find(order => order.status === OrderStatusTypeEnum.FAILED),
        });
    }

    public getLastScheduledDateExec = (): Date | null => {
        return this.newOrders ? this.newOrders.reduce((dateMax, order) => {
            if(!order.scheduledDateExec) {
                return new Date();
            }
            return order.scheduledDateExec < dateMax ? new Date(order.scheduledDateExec) : new Date(dateMax)
        }, this.newOrders[0].scheduledDateExec || new Date()) : null
    }

    public getLastErrorMessage = ():string => {
        if (!this.isFailed) {
            return ''
        }
        const lastError = this.newOrders.find(order => order.lastError);
        return lastError ? lastError.lastError.message : '';
    }
}

export class CreateOrder {
    id: number;
    contractId: number;
    scheduledDateExec: Date | null;
    status: OrderStatusTypeEnum;
    reasonError: OrderErrorTypeEnum;
    lastError: any

    constructor(base?: Partial<CreateOrder>) {
        if (base) {
            Object.assign(this, base);
        }
    }

    public static fromDto(dto: ICreateOrderDTO) {
        return new CreateOrder({
            id: dto.id,
            contractId: dto.contract_id,
            scheduledDateExec: dto.scheduled_date_exec ? new Date(dto.scheduled_date_exec) : null,
            status: dto.status as OrderStatusTypeEnum,
            reasonError: dto.reason_error as OrderErrorTypeEnum,
            lastError: dto.last_error ? JSON.parse(dto.last_error) : null
        });
    }
}
